module.exports = __webpack_public_path__ + "static/media/Sec-4-Background.d513f79c.webp";